import PropTypes from 'prop-types';
import React from 'react';

import { ReactComponent as Success } from '../../../assets/icons/success.svg';

const COPY = {
  refund: {
    title: 'Refund submitted',
    message:
      'The payout is being processed. The customer will receive an email once it is completed.'
  },
  accept: {
    title: 'Dispute resolved',
    message:
      'The payment has been accepted and will proceed to settlement at the acceptance-time rate.'
  }
};

/** Final step — success confirmation. Closed via the modal's ✕ button. */
const SuccessStep = ({ variant }) => {
  const { title, message } = COPY[variant] || COPY.refund;
  return (
    <div className="resolve resolve--success">
      <Success className="resolve__success-icon" role="img" aria-label="success" />
      <h3 className="resolve__success-title" data-testid="resolve-success-title">
        {title}
      </h3>
      <p className="resolve__success-text">{message}</p>
    </div>
  );
};

SuccessStep.propTypes = {
  variant: PropTypes.oneOf(['refund', 'accept'])
};

export { SuccessStep };
